import { Injectable } from "@angular/core";
import { DetailedUserInterface } from "../../../core/interfaces/detailed-user-interface";
import { BackendService } from "../../../core/services/backend-service";
import { ContactCardInterface } from "src/app/core/interfaces/contact-card-interface";
import { UserScopeInterface } from "src/app/core/interfaces/user-scope-interface";

@Injectable({
  providedIn: "root",
})
export class DetailedUserService extends BackendService {
  constructor() {
    super();
  }

  getDetailedUser(): Promise<DetailedUserInterface> {
    return this.get<DetailedUserInterface>("api/detailed-users");
  }

  getContactRh(): Promise<ContactCardInterface[]> {
    return this.get<ContactCardInterface[]>("api/detailed-users/contact-rh");
  }

  getUserScope(): Promise<UserScopeInterface> {
    return this.get<UserScopeInterface>("api/detailed-users/scope");
  }
}
